module.exports = __webpack_public_path__ + "img/bread-easypay-scenarios.c53ab36b.png";